import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=9ca7923c&scoped=true&lang=pug"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
import style0 from "./Message.vue?vue&type=style&index=0&id=9ca7923c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca7923c",
  null
  
)

export default component.exports